import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import { Mail } from '../utils/icons';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaDiscord, FaGithub } from 'react-icons/fa';

const COMPANY = 'Crespo Cyber Consulting LLC';

const Footer = () => {
  const { t } = useI18n();

  const socials = [
    { href: 'https://www.linkedin.com/in/miguel083', icon: FaLinkedinIn, label: 'LinkedIn' },
    { href: 'https://github.com/miguelcrespo', icon: FaGithub, label: 'GitHub' },
    { href: 'https://github.com/CrespoCyberConsultingLLC', icon: FaGithub, label: 'GitHub (Crespo Cyber Consulting)' },
    { href: 'https://discord.gg/mnCyXtzqyU', icon: FaDiscord, label: t('footer.discordAriaLabel') },
    { href: 'https://facebook.com/crespocyberconsulting', icon: FaFacebookF, label: 'Facebook' },
    { href: 'https://twitter.com/crespocyber', icon: FaTwitter, label: 'Twitter / X' },
  ];

  const quickLinks = [
    { to: '/services', label: t('nav.services') },
    { to: '/projects', label: t('nav.projects') },
    { to: '/about', label: t('nav.about') },
    { to: '/blog', label: t('nav.blog') },
  ];

  return (
    <footer className="ccc-footer">
      <div className="ccc-container py-12">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(16rem,0.35fr)_minmax(18rem,0.45fr)]">
          <div>
            <img src="/images/badges/crespo-15.png" alt={COMPANY} className="h-14 w-auto" />
            <p className="mt-5 max-w-xl text-sm leading-7 text-slate-300">{t('footer.blurb')}</p>
            <div className="mt-6 grid max-w-2xl gap-3 border-t border-white/10 pt-5 sm:grid-cols-3">
              <div>
                <p className="ccc-label">{t('ui.lane')}</p>
                <p className="mt-2 text-sm font-bold text-white">{t('ui.detectionIR')}</p>
              </div>
              <div>
                <p className="ccc-label">{t('ui.ownership')}</p>
                <p className="mt-2 text-sm font-bold text-white">{t('ui.veteranOwned')}</p>
              </div>
              <div>
                <p className="ccc-label">{t('ui.base')}</p>
                <p className="mt-2 text-sm font-bold text-white">{t('ui.fortKnox')}</p>
              </div>
            </div>
          </div>

          <nav aria-label="Footer navigation">
            <h3 className="text-sm font-black uppercase tracking-[0.14em] text-white">{t('footer.quickLinks')}</h3>
            <ul className="mt-5 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link className="text-sm text-slate-300 transition hover:text-white" to={link.to}>
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link className="text-sm text-slate-300 transition hover:text-white" to="/privacy-policy">
                  {t('footer.privacy')}
                </Link>
              </li>
              <li>
                <Link className="text-sm text-slate-300 transition hover:text-white" to="/terms-of-service">
                  {t('footer.terms')}
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-black uppercase tracking-[0.14em] text-white">{t('footer.opportunities')}</h3>
            <p className="mt-5 text-sm leading-7 text-slate-300">{t('footer.opportunitiesText')}</p>
            <a
              href="mailto:info@crespocyberconsulting.com"
              className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-white transition hover:text-emerald-300"
            >
              <Mail className="h-5 w-5 text-emerald-300" />
              {t('footer.email')}
            </a>
            <div className="mt-6 flex flex-wrap gap-3">
              {socials.map(({ href, icon: Icon, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="inline-flex h-9 w-9 items-center justify-center border border-white/15 text-slate-300 transition hover:border-emerald-300 hover:text-emerald-300"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-5 text-xs text-slate-500">
          &copy; {new Date().getFullYear()} {COMPANY}. {t('footer.rights')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
